module.exports = __webpack_public_path__ + "img/cryptocurrency-400x300.df44cb5b.jpg";